(function () {

    'use strict';

    angular.module('app').config(carriersUrlConfig);

    carriersUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function carriersUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.when('/carriers/carrier-profiles/:id', {
            templateUrl: '/templates/pages/carriers/external-profiles-edit.html',
            controller: 'CarriersExternalProfilesEditController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-pencil',
                parent: 'carriers',
                subParent: 'carrierProfiles',
                htmlTitle: 'Carriers - Carrier Profile',
                pageTitle: 'Carriers - Carrier Profile'
            }
        }).when('/carriers/carrier-profiles/:id/zones', {
            templateUrl: '/templates/pages/carriers/postcode-profile.html',
            controller: 'PostcodeProfileController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-pencil',
                parent: 'carriers',
                subParent: 'carrierProfiles',
                htmlTitle: 'Carriers - Carrier Zones & Postcodes',
                pageTitle: 'Carriers - Carrier Zones & Postcodes',
                deepMenuParent: {
                    itemText: 'Carriers - Carrier Profile',
                    url: '/carriers/carrier-profiles/:id',
                }
            }
        }).when('/carriers/service-profiles', {
            templateUrl: '/templates/pages/carriers/services.html',
            controller: 'CarriersServicesController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-truck',
                parent: 'carriers',
                subParent: 'serviceProfiles',
                htmlTitle: 'Carriers - Service Profiles',
                pageTitle: 'Carriers - Service Profiles',
                deepMenuParent: {
                    withfilter: true,
                    filterName: 'carrierProfileId',
                    itemText: 'Carriers - Carrier Profile',
                    url: '/carriers/carrier-profiles/:id',
                }
            }
        }).when('/carriers/service-profiles/:id', {
            templateUrl: '/templates/pages/carriers/serviceProfile.html',
            controller: 'serviceProfileController',
            controllerAs: 'sv',
            params: {
                icon: 'fa fa-pencil',
                parent: 'carriers',
                subParent: 'serviceProfiles',
                htmlTitle: 'Carriers - Service Profile',
                pageTitle: 'Carriers - Service Profile'
            }
        }).when('/carriers/service-profiles/:id/rates', {
            templateUrl: '/templates/pages/carriers/load-rates-ctt.html',
            controller: 'LoadRatesCttController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-pencil',
                parent: 'carriers',
                subParent: 'serviceProfiles',
                htmlTitle: 'Carriers - Service Rates & Transit Times',
                pageTitle: 'Carriers - Service Rates & Transit Times',
                deepMenuParent: {
                    itemText: 'Carriers - Service Profile',
                    url: '/carriers/service-profiles/:id',
                }
            }
        }).when('/carriers/service-profiles/:id/rates/plywood', {
            templateUrl: '/templates/pages/carriers/plywood-rate-view.html',
            controller: 'PlywoodConfigController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-pencil',
                parent: 'carriers',
                subParent: 'serviceProfiles',
                htmlTitle: 'Carriers - Service Rates & Transit Times',
                pageTitle: 'Carriers - Service Rates & Transit Times',
                deepMenuParent: {
                    itemText: 'Carriers - Service Profile',
                    url: '/carriers/service-profiles/:id',
                }
            }
        }).when('/carriers/fuel-levies', {
            templateUrl: '/templates/pages/carriers/fuel-levies.html',
            controller: 'CarriersFuelLeviesController',
            controllerAs: 'vm',
            params: {
                parent: 'carriers',
                subParent: 'fuelLevies',
                htmlTitle: 'Carriers - Fuel Levies',
                pageTitle: 'Carriers - Fuel Levies'
            }
        }).when('/carriers/system-postcodes', {
            templateUrl: '/templates/pages/carriers/zones-postcodes.html',
            controller: 'CarriersZonePostcodeController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-truck',
                parent: 'carriers',
                subParent: 'systemEnabledPostcodes',
                htmlTitle: 'Carriers - System Zones & Postcodes Worldwide',
                pageTitle: 'Carriers - System Zones & Postcodes Worldwide'
            }
        }).when('/carriers/pop-lockers', {
            templateUrl: '/templates/pages/carriers/pop-locker-providers.html',
            controller: 'PopLockersProvidersController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-lock',
                parent: 'carriers',
                subParent: 'popLockers',
                htmlTitle: 'Carriers - POP Lockers',
                pageTitle: 'Carriers - POP Lockers'
            }
        }).when('/carriers/pop-lockers/:id', {
            templateUrl: '/templates/pages/carriers/pop-locker-provider-details.html',
            controller: 'PopLockerProviderDetailsController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-lock',
                parent: 'carriers',
                subParent: 'popLockers',
                htmlTitle: 'Carriers - POP Lockers',
                pageTitle: 'Carriers - POP Lockers'
            }
        }).when('/carriers/pop-lockers/add', {
            templateUrl: '/templates/pages/carriers/pop-locker-provider-details.html',
            controller: 'PopLockerProviderDetailsController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-lock',
                parent: 'carriers',
                subParent: 'popLockers',
                htmlTitle: 'Carriers - POP Lockers',
                pageTitle: 'Carriers - POP Lockers'
            }
        })
        /*.when('/carriers/postcode-create', {
            templateUrl: '/templates/pages/carriers/postcode-create.html',
            controller: 'CarriersPostCodeCreateController',
            params: {

                parent: 'carriers',
                subParent: '',
                htmlTitle: 'Carriers - New Zone Postcode File',
                pageTitle: 'Carriers - New Zone Postcode File'
            }
        }).when('/carriers/services/view/', {
            templateUrl: '/templates/pages/carriers/services-edit.html',
            controller: 'CarriersServicesEditController',
            params: {

                parent: 'carriers',
                htmlTitle: 'Service Profile Set-Up',
                pageTitle: 'Service Profile Set-Up'
            }
        }).when('/carriers/service-profile/view/:id', {
            templateUrl: '/templates/pages/carriers/service-profile-view.html',
            controller: 'CarrierServiceProfileViewController',
            controllerAs: 'vm',
            params: {

                parent: 'carriers',
                htmlTitle: 'Carriers - Service Profile View',
                pageTitle: 'Carriers - Service Profile View'
            }
        }).when('/carriers/service-profile/setup', {
            templateUrl: '/templates/pages/carriers/service-profile-setup.html',
            controller: 'CarrierServiceProfileSetupController',
            controllerAs: 'vm',
            params: {

                parent: 'carriers',
                htmlTitle: 'Carriers - Service Profile Setup',
                pageTitle: 'Carriers - Service Profile Setup'
            }
        }).when('/carriers/service-rate-cards/new', {
            templateUrl: '/templates/pages/carriers/service-profile-setup.html',
            controller: 'CarrierServiceProfileSetupController',
            controllerAs: 'vm',
            params: {

                parent: 'carriers',
                htmlTitle: 'Carriers - Service Profile Setup',
                pageTitle: 'Carriers - Service Profile Setup'
            }
        }).when('/carriers/service-rate-cards/view/:id', {
            templateUrl: '/templates/pages/carriers/service-profile-setup.html',
            controller: 'CarrierServiceProfileSetupController',
            controllerAs: 'vm',
            params: {

                parent: 'carriers',
                htmlTitle: 'Carriers - Service Profile Setup',
                pageTitle: 'Carriers - Service Profile Setup'
            }
        })*/;

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();



// WEBPACK FOOTER //
// ./js/urls/carriers.js